exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".errorContainer{position:fixed;top:10px;right:10px;max-width:350px;background-color:#fff;border:3px solid red;border-radius:5px;text-align:center;padding:10px;cursor:pointer;z-index:99;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/ErrorNotification/styles.css
// module id = 595
// module chunks = 1